import { render, staticRenderFns } from "./EditClientNotification.vue?vue&type=template&id=294a315a&"
import script from "./EditClientNotification.vue?vue&type=script&lang=js&"
export * from "./EditClientNotification.vue?vue&type=script&lang=js&"
import style0 from "./EditClientNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports